import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors, gradients, Spinner } from "../../theme";

const Container = styled.div`
  align-items: center;
  background-image: ${gradients.greyToPink("to bottom")};
  display: flex;
  height: 100%;
  opacity: ${(props) => (props.display ? 0.9 : 0)};
  ${(props) => !props.display && "pointer-events: none;"}
  left: 0;
  position: absolute;
  top: 0;
  transition: 0.8s;
  width: 100%;
  z-index: 2;

  > div {
    bottom: 112px;
    min-height: 138px;
    position: sticky;
    top: 200px;
    width: 100%;

    > div {
      transform: translateY(-2.5rem);
    }
  }
`;

const Check = styled.div`
  color: ${(props) => (props.error ? colors.red : colors.green)};
  font-size: 12rem;
  text-align: center;
  transform: ${(props) => (props.display ? "scale(1)" : "scale(0)")} !important;
  position: absolute;
  top: 0;
  transition: 0.4s;
  width: 100%;
`;

function OverlayLoader({ isVisible, error }) {
  const [display, setDisplay] = useState(isVisible);
  const [willHide, setWillHide] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setDisplay(isVisible);
    } else {
      setWillHide(true);
      setTimeout(() => {
        setDisplay(isVisible);
        setTimeout(() => {
          setWillHide(false);
        }, 800);
      }, 400);
    }
  }, [isVisible]);

  return (
    <Container display={display ? 1 : 0}>
      <div className="OverlayLoaderStickyWrapper">
        {!willHide && <Spinner color={colors.darkBlue}>Chargement...</Spinner>}
        <Check display={willHide ? 1 : 0} error={error}>
          {error ? (
            <i className="fas fa-times" />
          ) : (
            <i className="fas fa-check-double" />
          )}
        </Check>
      </div>
    </Container>
  );
}

OverlayLoader.propTypes = {
  isVisible: PropTypes.bool,
  error: PropTypes.bool,
};

export default OverlayLoader;
